import * as actions from "Actions";
import * as api from "Api";

export const fetchAlbum = ({
  limit = 7,
  isPersonal = 0,
  id = null,
  globalFetch = false
}) => (dispatch, getState) => {
  const { lng } = getState().params;
  const { auth } = getState();
  const { token, navCommunity } = auth;

  // const action = globalFetch ? actions.fetchAlbum : actions.fetchAlbums;
  if (token === "") {
    return api.getClientCredential().done(resp => {
      const help = typeof resp === "string" ? JSON.parse(resp) : resp;
      const clientToken = help.token.access_token;
      dispatch(actions.setAuthToken(clientToken));
      return dispatch(
        actions.fetchAlbum(
          api.getAlbums({
            token: clientToken,
            id,
            limit,
            lng,
            community: navCommunity ? navCommunity : null /*, sourceToken*/,
            isPersonal
          })
        )
      );
    });
  }
  return dispatch(
    actions.fetchAlbum(
      api.getAlbums({
        token,
        id,
        limit,
        lng,
        community: navCommunity ? navCommunity : null /*, sourceToken*/,
        isPersonal
      })
    )
  );
};

export const fetchAlbums = ({
  limit = 7,
  isPersonal = 0,
  id = null,
  globalFetch = false
}) => (dispatch, getState) => {
  const { lng } = getState().params;
  const { auth } = getState();
  const { token, navCommunity } = auth;

  // const action = globalFetch ? actions.fetchAlbum : actions.fetchAlbums;

  return dispatch(
    actions.fetchAlbums(
      api.getAlbums({
        token,
        id,
        limit,
        lng,
        community: navCommunity ? navCommunity : null /*, sourceToken*/,
        isPersonal
      })
    )
  );
};

export const fetchMyAlbums = () => (dispatch, getState) => {
  const { token, navCommunity, user } = getState().auth;

  return dispatch(
    actions.fetchAlbums(
      api.getMyAlbums({
        token,
        communityId: navCommunity.id,
        userId: user.id
      })
    )
  );
};

export const saveAlbum = ({
  id,
  titleFR,
  titleEN,
  titleNL,
  descriptionFR,
  descriptionEN,
  descriptionNL,
  color,
  tags,
  mediaIds,
  addMedia
} = {}) => (dispatch, getState) => {
  const { token, navCommunity } = getState().auth;
  const { lng } = getState().params;

  return dispatch(
    actions.saveAlbum(
      api.saveAlbum({
        token,
        lng,
        id,
        community: navCommunity,
        titleFR,
        titleEN,
        titleNL,
        descriptionFR,
        descriptionEN,
        descriptionNL,
        color,
        tags,
        mediaIds,
        addMedia
      })
    )
  );
};

export const fetchInfiniteAlbums = ({ limit, offset, isPersonal = 0 } = {}) => (
  dispatch,
  getState
) => {
  const { lng } = getState().params;
  const { auth, filter } = getState();
  const { token, navCommunity } = auth;

  return dispatch(
    actions.fetchInfiniteAlbums(
      api.getAlbums({
        token,
        limit,
        offset,
        lng,
        filterBy: filter.filterState,
        community: navCommunity /*, sourceToken*/,
        isPersonal
      })
    )
  );
};

export const deleteAlbum = id => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.deleteAlbum(
        api.deleteAlbum({
          token,
          id
        })
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/album.js